import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PreferencesState = { viewOffersAsList: boolean | undefined; isSidebarVisible: boolean };

const initialPreferencesState: PreferencesState = {
  viewOffersAsList: true,
  isSidebarVisible: false,
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: initialPreferencesState,
  reducers: {
    setViewOffersAsList: (state, action: PayloadAction<boolean>) => {
      state.viewOffersAsList = action.payload;
    },
    setSidebarVisibility: (state, action: PayloadAction<boolean>) => {
      state.isSidebarVisible = action.payload;
    },
    clearViewOffersAsList: (state) => {
      state.viewOffersAsList = initialPreferencesState.viewOffersAsList;
      state.isSidebarVisible = initialPreferencesState.isSidebarVisible;
    },
  },
});

export const { setViewOffersAsList, setSidebarVisibility, clearViewOffersAsList } =
  preferencesSlice.actions;

export default preferencesSlice.reducer;
